export enum USER_ROLES {
  ADMIN = 'admin',
  BROKER = 'broker',
  UNDERWRITER = 'underwriter',
  PARTNER = 'partner',
  PRICING_MAKER = 'pricing_maker',
  SCROLL_ADMIN = 'scroll_admin',
}
